import type { ActionValidationFailure, ActionValidationResult, GameState } from "../types";

function invalid(
  code: ActionValidationFailure["code"],
  message: string,
  path: string | null,
): ActionValidationResult {
  return { valid: false, failure: { code, message, path, details: {} } };
}

export function validateEndTurnAction(state: Readonly<GameState>): ActionValidationResult {
  if (state.schemaVersion !== 5) {
    return invalid(
      "ACTION_NOT_IMPLEMENTED",
      "End Turn is authoritative only in the public-beta V5 rules.",
      "schemaVersion",
    );
  }
  if (state.phase !== "action-window") {
    return invalid(
      "WRONG_PHASE",
      "End Turn is legal only from the public-beta action window.",
      "phase",
    );
  }
  if (state.supplyStatus.type !== "resolved") {
    return invalid(
      "SUPPLY_UPKEEP_UNRESOLVED",
      "Mandatory Supply choices must be resolved before ending the turn.",
      "supplyStatus",
    );
  }
  return { valid: true };
}
